import CarouselCard from './CarouselCard';
import './style.scss';

export default function CarouselCards({ containerID, sortedCards, handleScroll }) {
  return (
    <div
      className='grid grid-cols-[repeat(12,1fr)] w-full mb-3 md:mt-6 overflow-x-auto overflow-y-hidden overscroll-x-contain scroll-smooth snap-mandatory snap-x scrollable-carousel'
      onScroll={handleScroll}
      id={containerID}
      data-testid={`${containerID}-carousel-container`}
    >
      {sortedCards && sortedCards.map((obj) => <CarouselCard cardData={obj} key={obj.imageAltText} />)}
    </div>
  );
}
